// extracted by mini-css-extract-plugin
export var iconContainer = "_bg-0";
export var metricCardsContainer = "_bg-1";